// extracted by mini-css-extract-plugin
export default {"tags":"TagsWrapper_tags__xTwFo"};